export default __webpack_public_path__ + "static/media/AddressIcon.4182a112.svg";